import Vue from 'vue'
import VueApexCharts from '../components/common/ApexChart'

Vue.use(VueApexCharts)
Vue.component('Apexchart', VueApexCharts)
